Vue.config.devtools = true;

const app = new Vue({
    el: '.js-app',
    data: {
        isMobile: true,
        interestList: {
            open: false,
            body: null,
            draggable: false,
            plots: [],
            elemToIndex: null
        },
        countdowns: document.querySelectorAll('.js-countdown'),
        countDown: {
            // endDate: 'Dec 31, 2018 00:00:01',
            endDate: null,
            isActive: false,
            days: null,
            hours: null,
            minutes: null,
            seconds: null
        } 
    },
    computed: {
        interestedPlotsNboIds() {
            return app.interestList.plots.map(plot => (plot.NboId));
        }
    },
    mounted() {
        // Gets the plots saved in LocalStorage
        if(localStorage.getItem('interestedPlots') !== null) {
            this.interestList.plots = JSON.parse(localStorage.getItem('interestedPlots'));
        }
        this.body = document.getElementsByTagName("BODY")[0];
        this.isMobile = this.checkWindowWidth();
        window.addEventListener('resize', () => {
            this.isMobile = this.checkWindowWidth();
        })

        for(let i = 0; i <  this.countdowns.length; i+=1) {
            this.countDown.endDate = this.countdowns[i].dataset.endDate;
            this.countDown.endDate = new Date(this.countDown.endDate).getTime();
            setInterval(this.calculateTimeLeft, 1000);
        }
    },
    filters: {
        formatCurrency(input) {
            return input.toLocaleString("nl-NL", {style: 'currency', currency: 'EUR', minimumFractionDigits: 0});
        }
    },
    methods: {
        calculateTimeLeft() {
            let startDate = new Date();
            startDate = startDate.getTime();

            let timeRemaining = parseInt((this.countDown.endDate - startDate) / 1000);

            if(isNaN(timeRemaining)) {
                return;
            } else {
                if(timeRemaining > 0) {
                    this.countDown.isActive = true;
                    this.countDown.days = ('0' + parseInt(timeRemaining / 86400)).slice(-2);
                    timeRemaining = timeRemaining % 86400;

                    this.countDown.hours = ('0' + parseInt(timeRemaining / 3600)).slice(-2);
					timeRemaining = (timeRemaining % 3600);

					this.countDown.minutes = ('0' + parseInt(timeRemaining / 60)).slice(-2);
					timeRemaining = (timeRemaining % 60);

					this.countDown.seconds = ('0' + parseInt(timeRemaining)).slice(-2);
                } else {
                    this.countDown.isActive = false;
                }
            }
        },
        toggleInterestList() {
            app.interestList.open = !app.interestList.open;
            if(window.innerWidth < 768) {
                if(app.interestList.open) {
                    app.body.classList.add('no-scroll');
                } else {
                    app.body.classList.remove('no-scroll');
                }
            }

            Vue.nextTick(() => {
                if (!this.interestList.draggable) {
                    draggable.createDraggable(document.querySelector('.interests__list__drag'));
                    this.interestList.draggable = true;
                }
            });
        },
        addPlot(plot) {
            //if (plot.PriceFrom == 0) {
            //    plot.PriceFrom = 'n.n.b.'
            //}

            //check if in list
            // Add Plot to the InterestList
            if (this.plotNotInInterestList(plot) || !this.plotIsSold(plot)) {
                app.interestList.plots.push(plot);
                app.updateLocalStorage();
                // app.interestList.open = true;
                // this.toggleInterestList();

                if(!app.interestList.open) {
                    app.interestList.open = true;
                    if(window.innerWidth < 768) {
                        app.body.classList.add('no-scroll');
                    }
                }

                Vue.nextTick(() => {
                    // if (!this.interestList.draggable) {
                        draggable.createDraggable(document.querySelector('.interests__list__drag'));
                        this.interestList.draggable = true;
                    // }
                });
            }
        },
        removePlot(plot) {
            // Remove Plot from InterestList based on NboId
            app.interestList.plots = app.interestList.plots.filter((p) => p.NboId != plot.NboId);
            app.updateLocalStorage();
            if(app.interestList.plots.length === 0) {
                this.toggleInterestList();
            }

            draggable.createDraggable(document.querySelector('.interests__list__drag'));
            this.interestList.draggable = true;
        },
        removePlotQuestion(plot) {
            let comfirmMsg = document.querySelector('.js-interestlist-delete').dataset.deleteMsg;
            let answer = confirm(comfirmMsg);
            if(answer) {
                this.removePlot(plot);
            }
        },
        updateLocalStorage() {
            // Update LocalStorage with new InterestedPlots array
            if(app.interestList.plots.length > 0) {
                localStorage.setItem('interestedPlots', JSON.stringify(app.interestList.plots));
            } else {
                localStorage.removeItem('interestedPlots');
            }
        },
        plotNotInInterestList(plot) {
            const duplicatePlot = this.interestList.plots.filter((p) => {
                return p.NboId === plot.NboId;
            });

            if(duplicatePlot.length) {
                return false;
            }
            return true;
        },
        plotIsSold(plot) {
            if (plot.Status === "IsSold") {
                return true;
            }
            return false;
        },
        submitInterestedForm(e) {
            const interestedForm = e.target;
            if($(interestedForm).valid()) {
                localStorage.removeItem('interestedPlots');
            }
        },
        moveItem(e) {
            // this.interestList.sortableItems = document.querySelectorAll('.js-interestlist-row');
            let item = e.target.closest('.interestlist-sort__row');
            let elemTo = e.target.classList.contains('move-up') ? item.previousElementSibling : item.nextElementSibling;

            let fromIndex = parseInt(item.dataset.index, 10);
            let toIndex = e.target.classList.contains('move-up') ? fromIndex - 1 : fromIndex + 1;
            this.interestList.elemToIndex = toIndex;

            if (item !== null && elemTo !== null) {
                this.interestList.plots.splice(toIndex, 0, this.interestList.plots.splice(fromIndex, 1)[0]);
            }

            e.target.blur();
        },
        checkWindowWidth() {
            return (window.outerWidth < 1400 && !this.body.classList.contains('non-touch-device'));
        }
    }
});